import { invoiceAmounts } from '../../utils/invoiceAmounts';
import { formatRupiah } from '../../utils/printHelper';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { id } from 'date-fns/locale';
import { Printer } from 'lucide-react';

export function BuktiTukarDialog({ buktiTukarData, printBuktiTukarFaktur, setShowBuktiTukar, showBuktiTukar }) {
  return (
    <Dialog open={showBuktiTukar} onOpenChange={setShowBuktiTukar}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between">
            <span className="text-green-600">Bukti Tanda Terima Tukar Faktur</span>
            <Button size="sm" onClick={printBuktiTukarFaktur} data-testid="print-bukti-tukar-confirm">
              <Printer className="h-4 w-4 mr-2" /> Print
            </Button>
          </DialogTitle>
        </DialogHeader>
        {buktiTukarData && (
          <div className="space-y-4">
            <div className="bg-green-50 p-4 rounded-lg border border-green-200">
              <p className="font-bold text-lg text-green-700">{buktiTukarData.bukti_tukar_number}</p>
            </div>

            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <p className="text-slate-500">No. Invoice</p>
                <p className="font-semibold">{buktiTukarData.invoice_number}</p>
              </div>
              <div>
                <p className="text-slate-500">Tanggal Tukar</p>
                <p className="font-semibold">{new Date(buktiTukarData.tanggal_tukar).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
              </div>
              <div>
                <p className="text-slate-500">Supplier</p>
                <p className="font-semibold">{buktiTukarData.supplier_name}</p>
              </div>
              <div>
                <p className="text-slate-500">Perusahaan</p>
                <p className="font-semibold">{buktiTukarData.company_name}</p>
              </div>
              <div>
                <p className="text-slate-500">Nilai Dibayarkan</p>
                <p className="font-semibold font-mono">Rp {formatRupiah(invoiceAmounts(buktiTukarData).nilaiDibayarkan)}</p>
              </div>
              {buktiTukarData.po_number && (
                <div>
                  <p className="text-slate-500">No. PO</p>
                  <p className="font-semibold">{buktiTukarData.po_number}</p>
                </div>
              )}
            </div>

            {buktiTukarData.catatan && (
              <div className="bg-slate-50 p-3 rounded">
                <p className="text-sm text-slate-500">Catatan:</p>
                <p className="text-sm">{buktiTukarData.catatan}</p>
              </div>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
